module.exports = __webpack_public_path__ + "static/media/logo_logs.96332e0d.png";